import React from 'react'

class DesignerActions extends React.Component {
  render() {
    return (
      <div className="d-flex justify-content-end p-2">
        { this.props.deletable ?
          <a href="javascript:;" className="btn-flat red-text" onClick={this.props.handleDelete}>Delete</a> :
            <a href={this.props.cancelPath} className="btn-flat blue-text">Cancel</a>
        }
        <div className="ml-auto">
          <button className="btn btn-primary cursor-pointer">Save Annotation</button>
        </div>
      </div>
    )
  }
}

export default DesignerActions
